__turbopack_context__.v({
  "cta-desktop": "Navbar-module__l9IAVq__cta-desktop",
  "cta-icon": "Navbar-module__l9IAVq__cta-icon",
  "cta-section": "Navbar-module__l9IAVq__cta-section",
  "dark-bg": "Navbar-module__l9IAVq__dark-bg",
  "hamburger-icon": "Navbar-module__l9IAVq__hamburger-icon",
  "hamburger-trigger": "Navbar-module__l9IAVq__hamburger-trigger",
  "header": "Navbar-module__l9IAVq__header",
  "header-background": "Navbar-module__l9IAVq__header-background",
  "header-background-dark": "Navbar-module__l9IAVq__header-background-dark",
  "header-background-hidden": "Navbar-module__l9IAVq__header-background-hidden",
  "header-background-visible": "Navbar-module__l9IAVq__header-background-visible",
  "header-mount": "Navbar-module__l9IAVq__header-mount",
  "headerMount": "Navbar-module__l9IAVq__headerMount",
  "logo-container": "Navbar-module__l9IAVq__logo-container",
  "logo-dark": "Navbar-module__l9IAVq__logo-dark",
  "logo-image": "Navbar-module__l9IAVq__logo-image",
  "logo-light": "Navbar-module__l9IAVq__logo-light",
  "logo-link": "Navbar-module__l9IAVq__logo-link",
  "logo-section": "Navbar-module__l9IAVq__logo-section",
  "mobile-cta-button": "Navbar-module__l9IAVq__mobile-cta-button",
  "mobile-cta-group": "Navbar-module__l9IAVq__mobile-cta-group",
  "mobile-cta-icon": "Navbar-module__l9IAVq__mobile-cta-icon",
  "mobile-menu-wrap": "Navbar-module__l9IAVq__mobile-menu-wrap",
  "mobile-nav": "Navbar-module__l9IAVq__mobile-nav",
  "mobile-nav-item": "Navbar-module__l9IAVq__mobile-nav-item",
  "mobile-nav-link": "Navbar-module__l9IAVq__mobile-nav-link",
  "nav-desktop": "Navbar-module__l9IAVq__nav-desktop",
  "nav-link": "Navbar-module__l9IAVq__nav-link",
  "nav-section": "Navbar-module__l9IAVq__nav-section",
  "navbar": "Navbar-module__l9IAVq__navbar",
  "navbar-default": "Navbar-module__l9IAVq__navbar-default",
  "navbar-default-dark": "Navbar-module__l9IAVq__navbar-default-dark",
  "navbar-scrolled": "Navbar-module__l9IAVq__navbar-scrolled",
  "navbar-scrolled-dark": "Navbar-module__l9IAVq__navbar-scrolled-dark",
  "sheet-close-btn": "Navbar-module__l9IAVq__sheet-close-btn",
  "sheet-close-icon": "Navbar-module__l9IAVq__sheet-close-icon",
  "sheet-close-row": "Navbar-module__l9IAVq__sheet-close-row",
  "sheet-content": "Navbar-module__l9IAVq__sheet-content",
  "sr-only": "Navbar-module__l9IAVq__sr-only",
});
